import fetch from 'utils/fetch';


export function moudleList() {
    const data = {
    };
    return fetch({
        url: '/getMoudleList',
        method: 'get',
        params:data
    });
}


// WEBPACK FOOTER //
// ./src/api/moudle.js